import styled from 'styled-components';
import { ColorNeutralGrey5, Spacing4, Spacing8, Spacing12 } from 'autogen/design-tokens/tokens';
import Card from 'components/generic/card';
import NavigationLink from 'components/shared/Routing';
import LinkAction from 'components/shared/Routing/components/LinkAction/LinkAction';
import { breakpoint } from 'variables';

export const ProductCard = styled(Card)`
    border: 1px solid ${ColorNeutralGrey5};
    border-radius: 0;
    ${({ theme }) => (theme as any).ProductCard};
`;

export const ProductContent = styled(Card.Content)`
    display: grid;
    gap: ${Spacing8};
    grid-template-rows: min-content auto auto;
    text-decoration: none;
    padding: 0;
`;

export const ProductCardTop = styled(LinkAction)`
    display: flex;
    justify-content: center;
    align-items: flex-end;
    height: 164px;
    position: relative;
`;

export const ProductCardMid = styled.div`
    display: grid;
    align-self: flex-start;
    grid-template-rows: repeat(auto-fit, minmax(16px, auto));
    gap: ${Spacing8};

    ${({ theme }) => (theme as any).ProductCardMid}
`;

export const ProductCardBottom = styled.div`
    display: grid;
    align-self: flex-end;
    gap: ${Spacing8};
    ${({ theme }) => (theme as any).ProductCardBottom}
`;

export const ProductActionContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr auto;
    gap: ${Spacing4};
`;
